import { render, staticRenderFns } from "./DuplicacionConsumoAgua.vue?vue&type=template&id=56a0c6d5&scoped=true"
import script from "./DuplicacionConsumoAgua.vue?vue&type=script&lang=ts"
export * from "./DuplicacionConsumoAgua.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0c6d5",
  null
  
)

export default component.exports